// extracted by mini-css-extract-plugin
export var searchHeader = "_6j-0";
export var searchHeaderDark = "_6j-1";